module.exports = __webpack_public_path__ + "img/xmark.0bcd41f9.svg";